import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft, ArrowRight } from 'lucide-react';

import Spinner from 'components/Spinner';

export const Button = (props) => {
  const { label, modifier, className, isDisabled, isLoading, onClick, arrow, iconGap, icon: Icon, ...rest } = props;

  const baseClasses = 'text-center font-medium text-base leading-[19.5px] px-6 py-4 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

  const modifierClasses = {
    primary: 'bg-blue-500 hover:bg-blue-700 text-white focus:ring-blue-500 disabled:bg-blue-300',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white focus:ring-gray-500 disabled:bg-gray-300',
    outline: 'border border-blue-500 text-blue-500 hover:bg-blue-400 hover:border-blue-400 hover:text-white focus:ring-blue-400 disabled:border-blue-300 disabled:text-blue-300',
    dark: 'bg-gray-600 hover:bg-gray-900 text-white focus:ring-gray-500 disabled:bg-gray-300',
    light: 'bg-sky-100 hover:bg-blue-100 text-blue-500 focus:ring-blue-300 disabled:bg-blue-25 disabled:text-blue-300',
    danger: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500 disabled:bg-red-300',
  };

  const disabledClasses = 'disabled:cursor-not-allowed disabled:opacity-50';

  const finalClassName = `${baseClasses} ${modifierClasses[modifier] || modifierClasses.primary} ${disabledClasses} ${className}`;

  return (
    <button
      type="button"
      className={finalClassName}
      onClick={onClick}
      disabled={isDisabled || isLoading}
      {...rest}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <div className={`flex items-center justify-center gap-${iconGap}`}>
          {arrow === 'left' && <ArrowLeft size={22} />}
          {Icon && <Icon size={18} />}
          <span>{label}</span>
          {arrow === 'right' && <ArrowRight size={22} />}
        </div>
      )}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  modifier: PropTypes.oneOf(['primary', 'secondary', 'outline', 'dark', 'light', 'danger']),
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  arrow: PropTypes.oneOf(['left', 'right']),
  isLoading: PropTypes.bool,
  icon: PropTypes.node,
  iconGap: PropTypes.number,
};

Button.defaultProps = {
  className: '',
  modifier: 'primary',
  onClick: () => {},
  isLoading: false,
  isDisabled: false,
  arrow: null,
  icon: null,
  iconGap: 4,
};

export default Button;
